import Vue from 'vue';
import Card from 'src/components/Card/Card';
import intlNumberFormat from 'src/utils/intlOperations/intlNumberFormat';
export default Vue.extend({
    components: { Card },
    data() {
        return {
            value: {},
            callBackForSaving: null,
            title: '',
            visible: null,
            example: 11.1111
        };
    },
    computed: {
        exampleFormatted() { return intlNumberFormat(this.example, this.value); }
    },
    watch: {
        'value.style'(newVal, oldVal) {
            if (newVal === 'currency') {
                this.value.currency = 'USD';
            }
            else if (newVal === 'percent') {
                if (this.example > 1)
                    this.example = this.example / 100;
            }
            else if (oldVal === 'percent') {
                if (this.example < 1)
                    this.example = this.example * 100;
            }
        }
    },
    methods: {
        openDialog(params) {
            const { value, callBackForSaving, title } = params;
            this.visible = true;
            if (value)
                this.value = Object.assign({}, value);
            if (callBackForSaving)
                this.callBackForSaving = callBackForSaving;
            if (title)
                this.title = title;
        },
        save() {
            const obj = this.value;
            if (obj.style === 'currency' && (!obj.currency || obj.currency.length !== 3)) {
                this.$q.notify({ color: 'negative', message: '3-letter ISO currency code is required where display style Currency is selected' });
                return;
            }
            if (this.callBackForSaving && this.value) {
                this.callBackForSaving(this.value);
            }
            this.visible = false;
        }
    }
});
